import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostListener,
  Inject,
  inject,
  input,
  OnInit,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import {SearchWidgetThemeEnum} from '../../enums/search-widget-theme.enum';
import {DLPageTypeEnum} from '../../../../enums/DataLayerEnums';
import {WindowSizeService} from '../../../../services/window-size.service';
import {isPlatformBrowser} from '@angular/common';
import {SearchWidgetManagerService} from '../../../../services/search-widget/search-widget-manager.service';

@Component({
  selector: 'app-search-widget-toppage-wrapper',
  templateUrl: './search-widget-toppage-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchWidgetTopPageWrapperComponent implements OnInit {
  mainCareProviderTypeId = input<number>();
  inferredCareProviderTypeAreaId = input<number>();
  inferredCategoryTypeId = input<number>();
  pageType = input<DLPageTypeEnum>();
  hideFiltersAndPlacePanel = input<boolean>();
  customCssClass = input<string>();
  protected readonly searchWidgetThemeEnum = SearchWidgetThemeEnum;
  protected topSpacerInViewport = signal<boolean>(true);
  protected fixedWidget = signal<boolean>(false);
  private windowSizeService = inject(WindowSizeService);
  private windowSize = this.windowSizeService.windowSize;
  private headerSize = computed<number>(() => {
    return this.windowSize()[0] >= 992 ? 4 * 16 : 3 * 16;
  });
  private widgetManager = inject(SearchWidgetManagerService);

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  public handleTopSpacerInViewport(inViewport: boolean): void {
    this.topSpacerInViewport.set(inViewport);
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.recalculateFixedPosition();
  }

  public ngOnInit() {
    this.recalculateFixedPosition();
  }

  private recalculateFixedPosition(): void {
    if (isPlatformBrowser(this.platformId)) {
      const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const fixedWidgetCalculation = this.headerSize() - verticalOffset < 0;
      if (this.fixedWidget() !== fixedWidgetCalculation) {
        this.fixedWidget.set(fixedWidgetCalculation);
        this.widgetManager.setFixedWidgetPosition(this.fixedWidget());
      }
    }
  }
}
